var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPayment(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "66px",
    height: "46px",
    viewBox: "0 0 66 46",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Pago") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "65.9255338 45.1387527 0 45.1387527 0 0.174373448 65.9255338 0.174373448 65.9255338 45.1387527"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Desktop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Home_V1",
    transform: "translate(-207.000000, -5453.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Footer",
    transform: "translate(0.000000, 5370.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-42",
    transform: "translate(120.000000, 83.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Pago",
    transform: "translate(87.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-17"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.910344828,4.06615666 C0.910344828,2.40803016 2.28769655,1.06365135 3.98457931,1.06365135 L61.941,1.06365135 C63.6387931,1.06365135 65.0152345,2.40358299 65.0152345,4.06615666 L65.0152345,41.246925 C65.0152345,42.9050515 63.6378828,44.2494304 61.941,44.2494304 L3.98457931,44.2494304 C2.28678621,44.2494304 0.910344828,42.9094987 0.910344828,41.246925 L0.910344828,4.06615666 Z",
    id: "Fill-1",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-5"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.98453379,1.95324055 C2.7915269,1.95324055 1.82064414,2.90115436 1.82064414,4.06608995 L1.82064414,41.2468583 C1.82064414,42.4120163 2.7915269,43.3599301 3.98453379,43.3599301 L61.9409545,43.3599301 C63.1339614,43.3599301 64.1048441,42.4120163 64.1048441,41.2468583 L64.1048441,4.06608995 C64.1048441,2.90115436 63.1339614,1.95324055 61.9409545,1.95324055 L3.98453379,1.95324055 Z M3.98453379,45.1387972 C1.78741655,45.1387972 -4.55172414e-05,43.3928391 -4.55172414e-05,41.2468583 L-4.55172414e-05,4.06608995 C-4.55172414e-05,1.92033151 1.78741655,0.174373448 3.98453379,0.174373448 L61.9409545,0.174373448 C64.1382993,0.174373448 65.9255338,1.92033151 65.9255338,4.06608995 L65.9255338,41.2468583 C65.9255338,43.3928391 64.1382993,45.1387972 61.9409545,45.1387972 L3.98453379,45.1387972 Z",
    id: "Fill-3",
    fill: "#484848",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M17.2894738,15.6912088 C19.8525497,15.6912088 21.9301841,13.6859809 21.9301841,11.2122438 C21.9301841,8.73850675 19.8525497,6.73327881 17.2894738,6.73327881 C14.7263979,6.73327881 12.6487634,8.73850675 12.6487634,11.2122438 C12.6487634,13.6859809 14.7263979,15.6912088 17.2894738,15.6912088",
    id: "Fill-6",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.289451,7.6227346 C15.2325269,7.6227346 13.5590855,9.23283169 13.5590855,11.2122661 C13.5590855,13.1914781 15.2325269,14.8017975 17.289451,14.8017975 C19.3463752,14.8017975 21.0200441,13.1914781 21.0200441,11.2122661 C21.0200441,9.23283169 19.3463752,7.6227346 17.289451,7.6227346 M17.289451,16.5806646 C14.2286441,16.5806646 11.7383959,14.1723009 11.7383959,11.2122661 C11.7383959,8.25200884 14.2286441,5.8438675 17.289451,5.8438675 C20.3502579,5.8438675 22.8407338,8.25200884 22.8407338,11.2122661 C22.8407338,14.1723009 20.3502579,16.5806646 17.289451,16.5806646",
    id: "Fill-8",
    fill: "#484848"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M48,32.7968781 C48,31.8044926 48.8268207,31 49.848,31 L58.3194414,31 C59.3399379,31 60.1672138,31.8049374 60.1672138,32.7968781 L60.1672138,37.9262414 C60.1672138,38.9186269 59.3406207,39.7231196 58.3194414,39.7231196 L49.848,39.7231196 C48.8272759,39.7231196 48,38.9181822 48,37.9262414 L48,32.7968781 Z",
    id: "Fill-11",
    fill: "#3782F7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-43",
    transform: "translate(5.000000, 6.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.61295862,10.2847647 C8.51764138,10.2847647 10.8724759,8.01203967 10.8724759,5.20854511 C10.8724759,2.40505056 8.51764138,0.132325477 5.61295862,0.132325477 C2.70827586,0.132325477 0.353441379,2.40505056 0.353441379,5.20854511 C0.353441379,8.01203967 2.70827586,10.2847647 5.61295862,10.2847647",
    id: "Fill-13",
    fill: "#3782F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.84244345,18.6277182 L1.66276759,18.6277182 C1.16002966,18.6277182 0.752422759,18.2294743 0.752422759,17.7382846 C0.752422759,17.2470949 1.16002966,16.8488511 1.66276759,16.8488511 L9.84244345,16.8488511 C10.3451814,16.8488511 10.7527883,17.2470949 10.7527883,17.7382846 C10.7527883,18.2294743 10.3451814,18.6277182 9.84244345,18.6277182",
    id: "Fill-17",
    fill: "#484848"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.59155655,28.0388813 L0.674315172,28.0388813 C0.360018621,28.0388813 0.105349655,27.7900622 0.105349655,27.4829853 C0.105349655,27.1759084 0.360018621,26.9270893 0.674315172,26.9270893 L6.59155655,26.9270893 C6.9058531,26.9270893 7.16052207,27.1759084 7.16052207,27.4829853 C7.16052207,27.7900622 6.9058531,28.0388813 6.59155655,28.0388813",
    id: "Fill-21",
    fill: "#484848"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2114848,28.0388813 L11.031809,28.0388813 C10.7175124,28.0388813 10.4628434,27.7900622 10.4628434,27.4829853 C10.4628434,27.1759084 10.7175124,26.9270893 11.031809,26.9270893 L19.2114848,26.9270893 C19.5257814,26.9270893 19.7804503,27.1759084 19.7804503,27.4829853 C19.7804503,27.7900622 19.5257814,28.0388813 19.2114848,28.0388813",
    id: "Fill-25",
    fill: "#484848"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8534731,31.7594708 L0.674383448,31.7594708 C0.360086897,31.7594708 0.105417931,31.5106517 0.105417931,31.2035748 C0.105417931,30.8964979 0.360086897,30.6476788 0.674383448,30.6476788 L15.8534731,30.6476788 C16.1677697,30.6476788 16.4224386,30.8964979 16.4224386,31.2035748 C16.4224386,31.5106517 16.1677697,31.7594708 15.8534731,31.7594708",
    id: "Fill-29",
    fill: "#484848"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2394786,18.6277182 L16.0598028,18.6277182 C15.5570648,18.6277182 15.1494579,18.2294743 15.1494579,17.7382846 C15.1494579,17.2470949 15.5570648,16.8488511 16.0598028,16.8488511 L24.2394786,16.8488511 C24.7422166,16.8488511 25.1498234,17.2470949 25.1498234,17.7382846 C25.1498234,18.2294743 24.7422166,18.6277182 24.2394786,18.6277182",
    id: "Fill-33",
    fill: "#484848"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.6365366,18.6277182 L30.4568607,18.6277182 C29.9541228,18.6277182 29.5465159,18.2294743 29.5465159,17.7382846 C29.5465159,17.2470949 29.9541228,16.8488511 30.4568607,16.8488511 L38.6365366,16.8488511 C39.1392745,16.8488511 39.5468814,17.2470949 39.5468814,17.7382846 C39.5468814,18.2294743 39.1392745,18.6277182 38.6365366,18.6277182",
    id: "Fill-37",
    fill: "#484848"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.2173931,18.6277182 L44.6699379,18.6277182 C44.1672,18.6277182 43.7595931,18.2294743 43.7595931,17.7382846 C43.7595931,17.2470949 44.1672,16.8488511 44.6699379,16.8488511 L53.2173931,16.8488511 C53.720131,16.8488511 54.1277379,17.2470949 54.1277379,17.7382846 C54.1277379,18.2294743 53.720131,18.6277182 53.2173931,18.6277182",
    id: "Fill-41",
    fill: "#484848"
  }))))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayment);
export default __webpack_public_path__ + "static/media/payment.c4da1642058b7451b249ea11147a5012.svg";
export { ForwardRef as ReactComponent };